import ReactDOM from 'react-dom';
import { useOutside } from "hooks/UseOutside";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { Container, ModalContainer } from './_servicesFilterModal';
import { ModalCloseButton } from '../SendDocumentsModal/_sendDocumentsModal';
import { Select } from '../Select/Select';
import api from 'services/api';
import { toast } from 'react-toastify';

interface IServicesFilterModalProps {
  toggleModal: Dispatch<SetStateAction<any>>;
  setFilterQuery: Dispatch<SetStateAction<string>>;
  callback?: () => void;
}

interface IOptions {
  label: string;
  value: string;
}

export const ServicesFilterModal = ({
  toggleModal,
  setFilterQuery,
  callback
}: IServicesFilterModalProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const [hideModal, setHideModal] = useState(false);

  const [ selectedService, setSelectedService ] = useState({
    label: '',
    value: ''
  } as IOptions);
  const [options, setOptions] = useState([] as IOptions[]);

  const handleSetValue = () => {
    setFilterQuery(`service_type_id=${selectedService.value}`);

    handleCloseModal();
  }

  const handleCloseModal = () => {
    setHideModal(true);

    setTimeout(() => {
      toggleModal({
        total: false,
        date: false,
        services: false
      });

      if(callback){
        callback();
      }
    }, 500);
  }

  const ensureServices = async () => {
    try {
      const response: any = await api.get('/service-types?limit=300')

      const services = response?.data?.results

      setOptions(services?.map((service: any) => ({
        label: service.name,
        value: service.id
      })))
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Oopps algo deu errado, tente novamente mais tarde.');
    }
  }

  useEffect(() => {
    ensureServices()
  }, [])

  useOutside(modalRef, handleCloseModal);

  if(!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <Container className={`${hideModal ? 'modal-services-filter--hide' : ''}`}>
      <ModalContainer ref={modalRef}>
        <ModalCloseButton
          type="button"
          onClick={handleCloseModal}
        >
          X
        </ModalCloseButton>
        <h1 className="modal-services-filter__title">
          Categoria de Serviços
        </h1>
        <Select
          options={options}
          className="modal-services-filter__select"
          defaultLabel="Serviços"
          selectedItem={selectedService}
          setSelectedItem={setSelectedService}
        />
        <button
          type="button"
          className="modal-services-filter__button"
          onClick={handleSetValue}
        >
          Confirmar
        </button>
      </ModalContainer>
    </Container>,
    modalRoot
  )
}
